export const isBCBSProvider = (provider: string | null | undefined): boolean => {
  if (!provider) return false;
  
  const normalizedProvider = provider.toLowerCase();
  return normalizedProvider.includes('blue cross') || 
         normalizedProvider.includes('blue shield') ||
         normalizedProvider.includes('bcbs') ||
         normalizedProvider.includes('anthem');
} 